import get from "lodash/get";

export const getFormErrorMessage = (e, ignoreFieldErrors) => {
  let fieldErrors = get(e, "response.data.errors", null);
  if (fieldErrors && ignoreFieldErrors){
    // do not show the names of the fields
    console.log(e);
    return '';
  }
  let jsonData = JSON.stringify(get(e, "response.data", null));
  let rootData = get(e, 'response.data', get(e, 'response', get(e, 'data', e)));

  // todo, fix on BE to have just 1 format
  return JSON.stringify(get(rootData, "message", get(rootData, "error", get(rootData, "msg", get(rootData, "errors", get(e, "response.data.errors", jsonData || "Error")))))).slice(0, 300);
};


// WEBPACK FOOTER //
// ./src/utils/errorHandler.js